import VideoTracker from '.';

export const assertPresenceOfPlayer = (player: VideoTracker['player']): jwplayer.JWPlayer => {
  if (!player) {
    throw new Error('Player must be defined at this point');
  }
  return player;
};
